new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {

    }
})

$(document).ready(function () {
    const footerSection = document.querySelectorAll('#footer .section-footer');
    if (footerSection.length) {
        footerSection.forEach((item) => {
            let footerContent = item.querySelector('.footer-title');
            item.addEventListener('click', (e) => {
                // Verifica se o clique foi em um link dentro do footer-list
                if (e.target.closest('.footer-list a') || e.target.closest('.footer-list .footer__item')) {
                    return; // Não faz nada se clicou em um link
                }
                item.classList.toggle('active');
                footerContent.classList.toggle('active');
            })
        });
    }
});